$(document).ready(function (e) {
  // Página blog
  const current_url = window.location.href;
  if (current_url.includes("blog")) {
    $(".navbar a").each((index, element) => {
      if (element.getAttribute("href").includes("blog")) {
        element.classList.add("active");
      }
    });
  }

  $(".navbar a").on("click", function () {
    $(".active").removeClass("active");
    $(this).addClass("active");
  });
});
